import Typography from '@mui/material/Typography';
import {useLayoutContext} from 'main/utility/AppContextProvider/LayoutContextProvider';
import FooterWrapper from './FooterWrapper';

const AppFooter = () => {
  const {footer, footerType, navStyle} = useLayoutContext();

  return (
    <>
      {footer &&
      footerType === 'fluid' &&
      navStyle !== 'h-default' &&
      navStyle !== 'hor-light-nav' &&
      navStyle !== 'hor-dark-layout' ? (
        <FooterWrapper className='footer'>
          <div className='footerContainer'>
            <Typography>
              All rights reserved. Yaman Solutions - FZCO, UAE &copy;{' '}
              {new Date().getFullYear()}
            </Typography>
          </div>
        </FooterWrapper>
      ) : null}
    </>
  );
};

export default AppFooter;
